<template>
     <section class="container mt-3 py-3 mb-5">
        <h4>Modales</h4>
        <!-- Implementación -->
        <div class="d-flex mb-2">
            <vs-button class="btn-primary" @click="verModal=true">Activar</vs-button>
            <vs-button class="btn-primary-variant" @click="verModal3=true">Eliminar</vs-button>
            <vs-button class="btn-secondary-variant" @click="err=false, nombre='', verModal2=true">Modal para formularios</vs-button>
        </div>
        
        <px-modal1
            v-show="verModal"
            @verModal="verModal = $event"
            idModal= 'ModalPrueba'
            textHeader='Modal de confirmación'
            modalWidth='500px'
        >
            <h3 class="text-center montserrat-500 mb-4">¿Esta seguro de activar el credito 002?</h3>
            <div class="d-flex justify-content-center">
                <vs-button class="btn-primary-o px-3" @click="verModal=false">Cerrar</vs-button>
                <vs-button class="btn-success px-2" @click="verModal=false">Activar</vs-button>
            </div>
        </px-modal1>


        <px-modal2
            v-show="verModal2"
            @verModal2="verModal = $event"
            idModal= 'ModalFormulario'
            textHeader='Modal de formularios'
            modalWidth='500px'
        >
            <div class="mb-2">
                <h6>Nombre del usuario</h6>
                <input type="text" v-model="nombre" class="form-control" placeholder="Añadir nombre" />
                <small v-if="err" class="text-danger">*Campo obligatorio</small>
            </div>
            <div class="d-flex justify-content-center">
                <vs-button class="btn-primary-o px-3" @click="verModal2=false">Cerrar</vs-button>
                <vs-button class="btn-secondary-variant px-2" @click="nombre==''? err=true : verModal2=false">Guardar</vs-button>
            </div>
        </px-modal2>

        <px-modal3
            v-show="verModal3"
            @verModal="verModal = $event"
            idModal= 'ModalEliminar'
            textHeader='Modal de Eliminación'
            modalWidth='500px'
        >
            <h3 class="text-center montserrat-500 mb-4">¿Esta seguro de Eliminar el credito 002?</h3>
            <div class="d-flex justify-content-center">
                <vs-button class="btn-primary-o px-3" @click="verModal3=false">Cerrar</vs-button>
                <vs-button class="btn-danger px-2" @click="verModal3=false">Eliminar</vs-button>
            </div>
        </px-modal3>



        <p class="text-dark my-0">Codigo para la implementación de modal de confirmación.</p>
        <!-- CODIGO HTML -->
        <div v-highlight>
<pre class="language-html"><code><script type="text/plain" class="language-markup"><vs-button class="btn-primary" @click="verModal=true">Modal de confirmación</vs-button>
<px-modal 
    v-show="verModal" 
    @verModal="verModal = $event" 
    idModal="ModalPrueba" 
    textHeader="Modal de confirmación"
    modalWidth="500px"
>
    <h3>Mi contenido aqui</h3>
    <div class="d-flex justify-content-center">
        <vs-button class="btn-primary-o px-3" @click="verModal=false">Cerrar</vs-button>
        <vs-button class="btn-success px-2" @click="verModal=false">Activar</vs-button>
    </div>
</px-modal>
</script></code></pre>
        </div>

        <p class="text-dark my-0">Codigo para la implementación de modal de confirmación</p>
        <!-- CODIGO VUE JS -->
        <div v-highlight><pre class="language-javascript"><code><script type="text/plain" class="language-markup">import PxModal from '@/components/PxModal.vue'
export default {
    components: {
        PxModal
    },
    data: function(){
        return{
            verModal: false
        }
    }
}</script></code></pre>
            </div>
        <!-- CODIGO VUE JS -->

        <div class="mb-3">
            <h5>Atributos <u>obligatorios</u> de componente generico modal</h5>
            <code>
                v-show="verModal" <br>
                @verModal="verModal = $event" <br>
                idModal= 'ModalFormulario' <br>
                textHeader='Titulo del modal'
            </code>
        </div>
        <div class="mb-5">
            <h5>Atributos <u>opcionales</u> de componente generico modal</h5>
            <code> modalWidth='500px' </code>
        </div>

        <div class="seccion-modal-fullscreen">
            <vs-button class="btn-primary" data-bs-toggle="modal" data-bs-target="#myModal"> Modal fullscreen</vs-button>
            <p class="m-0">Las propiedades <code>data-bs-backdrop="true" data-bs-keyboard="false"</code> permiten que el modal no se cierre al hacer click en Esc.</p>
        </div>
                
        <div class="modal-bootstrap">
            <div class="modal" id="myModal" data-bs-backdrop="true" data-bs-keyboard="false" tabindex="-1">
                <div class="modal-dialog modal-fullscreen">
                <div class="modal-content">
            
                    <!-- Modal Header -->
                    <div class="modal-header">
                    <h4 class="modal-title">Modal Heading</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                    </div>
            
                    <!-- Modal body -->
                    <div class="modal-body">
                        Modal pantalla completa, <strong>no se cierra automaticamente</strong> al presionar Esc.
                    </div>
            
                    <!-- Modal footer -->
                    <div class="modal-footer">
                        <vs-button class="btn-primary px-3" data-bs-dismiss="modal">Cerrar</vs-button>
                    </div>
            
                </div>
                </div>
            </div>
        </div>
        <div v-highlight>
    <pre class="language-html"><code><script type="text/plain" class="language-markup"><vs-button class="btn-secondary-primary" data-bs-toggle="modal" data-bs-target="#myModal">Modal fullscreen</vs-button>
    
    <div class="modal" id="myModal" data-bs-backdrop="true" data-bs-keyboard="false" tabindex="-1">
        <div class="modal-dialog modal-fullscreen">
        <div class="modal-content">
    
            <!-- Modal Header -->
            <div class="modal-header">
            <h4 class="modal-title">Modal Heading</h4>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
    
            <!-- Modal body -->
            <div class="modal-body">
                Contenido ...
            </div>
    
            <!-- Modal footer -->
            <div class="modal-footer">
                <vs-button class="btn-primary px-3" data-bs-dismiss="modal">Cerrar</vs-button>
            </div>
    
        </div>
        </div>
    </div>    </script></code></pre>
</div>


    </section>   
</template>

<script>
    import PxModal from '@/components/PxModal.vue'
    
    export default { 
        created(){
        window.scrollTo(0, 0);
        },
        
      name: 'ComponentePlantilla',
      components: {
        PxModal1: PxModal,
        PxModal2: PxModal,
        PxModal3:  PxModal,
        PxModalPrueba1: PxModal,
      },
      data: function(){
        return{
          verModal: false,
          confirmar: false,

          verModal2: false,
          nombre:'',
          err: false,

          verModal3: false,

          verModalPrueba1: false,
          nombre:'',
          err: false,
        }
      }
    }
</script>